module.exports = __webpack_public_path__ + "img/p1.b8c25668.png";